"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SURVEY_UPGRADE_PRODUCTS = exports.SURVEY_OPTIONS_BY_UPGRADE_PRODUCT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _SURVEY_OPTIONS_BY_UP;

var SURVEY_OPTIONS_BY_UPGRADE_PRODUCT = (_SURVEY_OPTIONS_BY_UP = {}, (0, _defineProperty2.default)(_SURVEY_OPTIONS_BY_UP, _UpgradeProducts.MARKETING_PRO, ['landing-pages', 'email', 'marketing-workflows', 'content-strategy']), (0, _defineProperty2.default)(_SURVEY_OPTIONS_BY_UP, _UpgradeProducts.SALES_PROFESSIONAL, ['sequences', 'meetings', 'quotes', 'sales-workflows']), (0, _defineProperty2.default)(_SURVEY_OPTIONS_BY_UP, _UpgradeProducts.MARKETING_ENTERPRISE, ['landing-pages', 'email', 'marketing-workflows', 'content-strategy']), (0, _defineProperty2.default)(_SURVEY_OPTIONS_BY_UP, _UpgradeProducts.SALES_ENTERPRISE, ['sales-workflows', 'playbooks', 'sequences', 'quotes']), (0, _defineProperty2.default)(_SURVEY_OPTIONS_BY_UP, _UpgradeProducts.SERVICE_ENTERPRISE, ['tickets', 'feedback', 'knowledge-base', 'service-workflows']), _SURVEY_OPTIONS_BY_UP);
exports.SURVEY_OPTIONS_BY_UPGRADE_PRODUCT = SURVEY_OPTIONS_BY_UPGRADE_PRODUCT;
var SURVEY_UPGRADE_PRODUCTS = [_UpgradeProducts.MARKETING_PRO, _UpgradeProducts.SALES_PROFESSIONAL, _UpgradeProducts.MARKETING_ENTERPRISE, _UpgradeProducts.SALES_ENTERPRISE, _UpgradeProducts.SERVICE_ENTERPRISE];
exports.SURVEY_UPGRADE_PRODUCTS = SURVEY_UPGRADE_PRODUCTS;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/trials.js
// module id = 469
// module chunks = 5 6